import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/faq/page.tsx");
